export const cleanName = (str: string) =>
  str.replace(/\s*\d+(\s*\d+)*\s*$/, '');
